import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import messages from './documentTemplateMessages';
const examples = [
    {
        category: 'AntiMoneyLaundering',
        message: messages.AntiMoneyLaundering,
        items: [
            // NL
            {
                url: 'https://static.adminpulse.eu/public/aml/nl/Identificatie%20persoon.docx',
                label: 'Identificatie persoon',
                templateType: 4,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Identificatie%20persoon.xlsx',
                label: 'Identificatie persoon (Excel)',
                templateType: 4,
                languageCode: 'nl',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl/Identificatie%20bedrijf.docx',
                label: 'Identificatie bedrijf',
                templateType: 5,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Identificatie%20bedrijf.xlsx',
                label: 'Identificatie bedrijf (Excel)',
                templateType: 5,
                languageCode: 'nl',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl/Risicobeoordeeling.docx',
                label: 'Risicobeoordeling',
                templateType: 6,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl/Begunstigden.docx',
                label: 'Begunstigden',
                templateType: 7,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl/Lasthebber%20persoon.docx',
                label: 'Lasthebber persoon',
                templateType: 8,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl/Lasthebber%20bedrijf.docx',
                label: 'Lasthebber bedrijf',
                templateType: 9,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl/Klantacceptatie.xlsx',
                label: 'Klantacceptatie',
                templateType: 20,
                languageCode: 'nl',
                notConfiguration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Klantacceptatie.xlsx',
                label: 'Klantacceptatie',
                templateType: 20,
                languageCode: 'nl',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Klantacceptatie (NOAB).docx',
                label: 'Klantacceptatie (NOAB)',
                templateType: 20,
                languageCode: 'nl',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Klantacceptatie%20Excel.xlsx',
                label: 'Klantacceptatie (Excel)',
                templateType: 20,
                languageCode: 'nl',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Klantcontinuatie%20Excel.xlsx',
                label: 'Klantcontinuatie (Excel)',
                templateType: 27,
                languageCode: 'nl',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Herkomst%20van%20gelden.docx',
                label: 'Herkomst van gelden',
                templateType: 29,
                languageCode: 'nl',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl/Risicobeoordeeling%20uitgebreid.docx',
                label: 'Risicoanalyse uitgebreid',
                templateType: 19,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Risicobeoordeling (NOAB).docx',
                label: 'Risicoanalyse uitgebreid (NOAB)',
                templateType: 19,
                languageCode: 'nl',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/nl-nl/Afgeleid klantonderzoek - D.1.c (NOAB).docx',
                label: 'Afgeleid klantonderzoek - D.1.c (NOAB)',
                templateType: 24,
                languageCode: 'nl',
                configuration: [5],
            },
            // FR
            {
                url: 'https://static.adminpulse.eu/public/aml/fr/Identification%20personel.docx',
                label: 'Identification personel',
                templateType: 4,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/fr/Identification%20entreprise.docx',
                label: 'Identification entreprise',
                templateType: 5,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/fr/Analyse%20du%20risque.docx',
                label: 'Analyse du risque',
                templateType: 6,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/fr/Bénéficiare.docx',
                label: 'Bénéficiaire',
                templateType: 7,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/fr/Fiduciaire%20personne.docx',
                label: 'Fiduciaire personne',
                templateType: 8,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/fr/Fiduciaire%20entreprise.docx',
                label: 'Fiduciaire entreprise',
                templateType: 9,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/fr/Acceptation%20des%20clients.xlsx',
                label: 'Acceptation des clients',
                templateType: 20,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/fr/Analyse%20du%20risque%20extensif.docx',
                label: 'Analyse du risque extensif',
                templateType: 19,
                languageCode: 'fr',
            },
            // EN
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Person%20verification.docx',
                label: 'Person verification',
                templateType: 4,
                languageCode: 'en',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Person%20verification.xlsx',
                label: 'Person verification (Excel)',
                templateType: 4,
                languageCode: 'en',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Legal%20entity%20verification.docx',
                label: 'Legal entity verification',
                templateType: 5,
                languageCode: 'en',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Legal%20entity%20verification.xlsx',
                label: 'Legal entity verification (Excel)',
                templateType: 5,
                languageCode: 'en',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Risk%20assessment.docx',
                label: 'Risk assessment',
                templateType: 6,
                languageCode: 'en',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Beneficiaries.docx',
                label: 'Beneficiaries',
                templateType: 7,
                languageCode: 'en',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Representative%20person.docx',
                label: 'Representative person',
                templateType: 8,
                languageCode: 'en',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Representative%20company.docx',
                label: 'Representative company',
                templateType: 9,
                languageCode: 'en',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Client%20acceptance.xlsx',
                label: 'Client acceptance',
                templateType: 20,
                languageCode: 'en',
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Client%20acceptance%20Excel.xlsx',
                label: 'Client acceptance (Excel)',
                templateType: 20,
                languageCode: 'en',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Client%20continuation%20Excel.xlsx',
                label: 'Client continuation (Excel)',
                templateType: 28,
                languageCode: 'en',
                configuration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/aml/en/Origin%20of%20the%20funds.docx',
                label: 'Origin of the funds',
                templateType: 29,
                languageCode: 'en',
                configuration: [5],
            },
        ],
    },
    {
        category: 'AuthorizationLetter',
        message: messages.AuthorizationLetter,
        items: [
            // NL
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/nl/Sjabloon%20fiscale%20volmacht%20-%20Bedrijf.docx',
                label: 'Fiscale volmacht - Bedrijf',
                templateType: 10,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/nl/Sjabloon%20fiscale%20volmacht%20-%20Eenmanszaak.docx',
                label: 'Fiscale volmacht - Eenmanszaak',
                templateType: 10,
                languageCode: 'nl',
            },
            // FR
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/fr/Modèle%20procuration%20fiscale%20-%20Société.docx',
                label: 'Procuration fiscale - Société',
                templateType: 10,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/fr/Modèle%20procuration%20fiscale%20-%20Entreprise%20Individuelle.docx',
                label: 'Procuration fiscale - Entreprise Individuelle',
                templateType: 10,
                languageCode: 'fr',
            },
        ],
    },
    {
        category: 'AssignmentLetter',
        message: messages.AssignmentLetter,
        notConfiguration: [5],
        items: [
            // NL
            {
                url: 'https://static.adminpulse.eu/public/assignment%20letters/nl/ITAA%202024%20-%20Model%20opdrachtbrief%20met%20algemene%20voorwaarden.docx',
                label: 'ITAA 2024 - Model opdrachtbrief met algemene voorwaarden',
                templateType: 3,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/assignment%20letters/nl/ITAA%202021%20-%20Aanhangsel%20bij%20de%20opdrachtbrief%20-%20UBO-register%20en%20GDPR.docx',
                label: 'ITAA 2021 - Aanhangsel bij de opdrachtbrief - UBO-register en GDPR',
                templateType: 3,
                languageCode: 'nl',
            },
            {
                url: 'https://static.adminpulse.eu/public/assignment%20letters/nl/ITAA%202023%20-%20Model%20opdrachtbrief%20PB%20consument.docx',
                label: 'ITAA 2023 - Model opdrachtbrief PB consument',
                templateType: 3,
                languageCode: 'nl',
            },
            // FR
            {
                url: 'https://static.adminpulse.eu/public/assignment%20letters/fr/ITAA%202024%20-%20Mod%C3%A8le%20lettre%20de%20mission%20avec%20conditions%20g%C3%A9n%C3%A9rales.docx',
                label: 'ITAA 2024 - Modèle lettre de mission avec conditions générales',
                templateType: 3,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/assignment%20letters/fr/ITAA%202021%20-%20Avenant%20%C3%A0%20la%20lettre%20de%20mission%20-%20registre%20UBO%20et%20RGPD.docx',
                label: 'ITAA 2021 - Avenant à la lettre de mission - registre UBO et RGPD',
                templateType: 3,
                languageCode: 'fr',
            },
            {
                url: 'https://static.adminpulse.eu/public/assignment%20letters/fr/ITAA%202023%20-%20Mod%C3%A8le%20lettre%20de%20mission%20IPP%20consommateur.docx',
                label: 'ITAA 2023 - Modèle lettre de mission IPP consommateur',
                templateType: 3,
                languageCode: 'fr',
            },
            // EN
            {
                url: 'https://static.adminpulse.eu/public/assignment%20letters/en/ITAA%202023%20-%20Engagement%20letter%20and%20its%20general%20terms%20and%20conditions.docx',
                label: 'ITAA 2023 - Engagement letter and its general terms and conditions',
                templateType: 3,
                languageCode: 'en',
            },
        ],
    },
    {
        category: 'Questionnaires',
        message: messages.Questionnaires,
        items: [
            // NL
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/nl/adminpulse-pb-questionnaire-nl.docx',
                label: 'Personenbelasting',
                templateType: 18,
                languageCode: 'nl',
                notConfiguration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/nl/AdminPulse_aangifte_inkomstenbelasting.docx',
                label: 'Inkomstenbelasting',
                templateType: 18,
                languageCode: 'nl',
                configuration: [5],
            },
            // FR
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/fr/adminpulse-pb-questionnaire-fr.docx',
                label: 'Impôt des personnes physiques',
                templateType: 18,
                languageCode: 'fr',
                notConfiguration: [5],
            },
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/en/adminpulse-pb-questionnaire-en.docx',
                label: 'Personal income tax',
                templateType: 18,
                languageCode: 'en',
                notConfiguration: [5],
            },
        ],
    },
    {
        category: 'Other',
        message: messages.Other,
        items: [
            // NL
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/nl/UBO-overzicht.docx',
                label: 'UBO overzicht',
                templateType: 99,
                languageCode: 'nl',
            },
            // FR
            {
                url: 'https://static.adminpulse.eu/public/Documentation%20files/fr/Aperçu UBO.docx',
                label: 'Aperçu UBO',
                templateType: 99,
                languageCode: 'fr',
            },
        ],
    },
];
const filterTenantConfiguration = (item, tenantConfiguration) => {
    if (!item)
        return false;
    if (!!item.notConfiguration && item.notConfiguration.length > 0) {
        if (item.notConfiguration.indexOf(tenantConfiguration) >= 0)
            return false;
    }
    if (!!item.configuration && item.configuration.length > 0) {
        if (item.configuration.indexOf(tenantConfiguration) < 0)
            return false;
    }
    return true;
};
const noEmptyCategories = (category) => category.items.length > 0;
const applyTenantConfigurationFilter = (categories, tenantConfiguration) => 
// Configuration filter on category
categories
    .filter(x => filterTenantConfiguration(x, tenantConfiguration))
    .map(x => (Object.assign(Object.assign({}, x), { items: x.items.filter(i => filterTenantConfiguration(i, tenantConfiguration)) })))
    .filter(noEmptyCategories);
const applyTenantLanguagesFilter = (categories, languages) => {
    if (!languages || languages.length === 0)
        return categories;
    return categories
        .map(x => (Object.assign(Object.assign({}, x), { items: x.items.filter(i => languages.indexOf(i.languageCode) >= 0) })))
        .filter(noEmptyCategories);
};
const applyCategoryFilters = (categories, languageCode, templateType) => categories
    .map(x => {
    const result = Object.assign({}, x);
    if (languageCode) {
        result.items = result.items.filter(t => t.languageCode === languageCode);
    }
    if (templateType) {
        result.items = result.items.filter(t => t.templateType === templateType);
    }
    return result;
})
    .filter(noEmptyCategories);
export const getLanguages = (categories) => {
    const languages = [];
    for (let c = 0; c < categories.length; c++) {
        const cat = categories[c];
        for (let i = 0; i < cat.items.length; i++) {
            const example = cat.items[i];
            if (languages.indexOf(example.languageCode) < 0)
                languages.push(example.languageCode);
            // Exit early when all 3 languages are found
            if (languages.length === 3)
                return languages;
        }
    }
    return languages;
};
export const getExamples = (tenantConfiguration, languages, languageCode, templateType) => {
    const categories = applyTenantLanguagesFilter(applyTenantConfigurationFilter(examples, tenantConfiguration), languages);
    // Use all filters
    let filteredExamples = applyCategoryFilters(categories, languageCode, templateType);
    if (filteredExamples.length > 0)
        return filteredExamples;
    if (languageCode) {
        // Try without language filter
        filteredExamples = applyCategoryFilters(categories, undefined, templateType);
        if (filteredExamples.length > 0)
            return filteredExamples;
    }
    if (templateType) {
        // Try without templateType filter
        filteredExamples = applyCategoryFilters(categories, languageCode, undefined);
        if (filteredExamples.length > 0)
            return filteredExamples;
    }
    filteredExamples = applyCategoryFilters(categories, undefined, undefined);
    return filteredExamples;
};
const searchCategory = (category, search, intl) => {
    if (!search)
        return category;
    if (!category)
        return category;
    // Return all examples if category label matches
    const translation = category.message && category.message.id ? intl.formatMessage(category.message) : null;
    if (translation && translation.toLowerCase().indexOf(search) >= 0)
        return category;
    // Filter examples by label
    return Object.assign(Object.assign({}, category), { items: category.items.filter(l => l.label && l.label.toLowerCase().indexOf(search) >= 0) });
};
export const searchExamples = (items, intl, search = '') => {
    if (!search)
        return items;
    const parts = search.split(' ');
    let result = items;
    parts.forEach(term => {
        result = result.map(x => searchCategory(x, term.toLowerCase(), intl)).filter(noEmptyCategories);
    });
    return result;
};
export const useExamples = (tenantConfiguration, tenantLanguages, languageCode, templateType, search) => {
    const intl = useIntl();
    const filteredExamples = useMemo(() => getExamples(tenantConfiguration, tenantLanguages, languageCode, templateType), [tenantConfiguration, tenantLanguages, languageCode, templateType]);
    return useMemo(() => {
        const searchedExamples = searchExamples(filteredExamples, intl, search);
        return {
            examples: searchedExamples,
            languages: getLanguages(searchedExamples),
        };
    }, [filteredExamples, intl, search]);
};
